import styled from 'styled-components';
import React from 'react';
import ColorConstants from '../../../constants/ColorConstants';

export const MetricName = styled.span`
    color: ${ColorConstants['regal-blue']};
    opacity: 1;
`;
export const ToolTipTitle = styled.div`
    font-weight: bold;
    text-align: left;
    color: ${ColorConstants['regal-blue']};
    opacity: 1;
`;
export const TooltipWholeText = styled.div`
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 15px;
    margin-right: 26px;
`;
export const ColorIndicator = styled.span`
    width: 10px;
    height: 10px;
    display: inline-block;
    background-color: ${({ color }) => color};
    border-radius: 50px;
    margin-right: 2px;
`;
export const Hotspottext = styled.div`
    margin-top: 5px;
`;
